import * as React from 'react'
import { SystemBreadCrumb } from './SystemBreadCrumb'

export const SystemBreadCrumbBar = () => {
    return <div className="top-sec d-none">
        <div className="container-fluid">
            <div className="row align-items-center m-0">
                <div className="col-md-6 mr-auto pl-0">
                    <SystemBreadCrumb />
                </div>
            </div>
        </div>
    </div>
}